import Topic from '../../../api/Topic';
import * as types from './mutation-types';

export const getTopic = async ({ commit }, { id }) => {
    const json = await new Topic().getTopic(id);

    commit(types.TOPIC, json);
};

export const startTopic = async (content, { id }) => {
    await new Topic().startTopic(id);
};

export const saveTopicTime = async (content, { id, params }) => {
    await new Topic().saveTopicTime(id, params);
};

export const finishTopic = async (content, { id }) => {
    const json = await new Topic().finishTopic(id);

    return json;
};

export default {
    getTopic,
    startTopic,
    saveTopicTime,
    finishTopic,
};



// WEBPACK FOOTER //
// ./src/store/modules/topic/actions.js